import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-invalid',
    templateUrl: './invalid.component.html',
    styleUrl: './invalid.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class InvalidComponent {
  
}
